import styled from '@emotion/styled'

import type { FC } from 'react'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import EmailForm from '../EmailForm'

const copy = {
  heading: <>Get every lesson delivered to&nbsp;your&nbsp;inbox</>,
  description: (
    <>Enter your email below and we’ll send lessons directly to you so&nbsp;you&nbsp;can&nbsp;learn at your own pace.</>
  ),
}

const EmailFormSection: FC = () => {
  return (
    <StyledSection variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description>{copy.description}</CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <EmailForm />
      </Section.Contents>
    </StyledSection>
  )
}

export default EmailFormSection

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    row-gap: 48px;
  }

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    ${Section.Wrapper} {
      row-gap: 32px;
    }
    ${Section.Copy} {
      max-width: 684px;
    }

    ${Section.Contents} {
      max-width: 417px;
    }
  }
`
